import {
  Box,
  Paper,
  Title,
  createStyles,
  Modal,
  Button,
  Text,
  SimpleGrid,
  Card,
} from "@mantine/core";

import healthConnnectLaunchIcon from "../../assets/img/healthConnectLaunchLogo.svg"

import { IconArrowRight } from "@tabler/icons-react";
import { embedApps } from "./Constant";
import { showNotification } from "@mantine/notifications";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  loader: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  card: {
    "&:hover": {
      boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
    },
  },
  group: { justifyContent: "space-between", height: "30px", width: "100%" },
  box1: { display: "flex", flexDirection: "column" },
  Boxtitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  cardHeading: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "left",
    alignItems: "center",
    width: "100%",
    marginBottom: "16px",
  },
  title: {
    fontWeight: 700,
    fontSize: "26px",
    lineHeight: "36px",
    color: "#262930",
  },
  breadCrumbs: {
    marginBottom: "50px",
    justifyContent: "space-between",
    display: "flex",
    alignItems: "center",
  },
  iconBox: {
    height: "32px",
    width: "32px",
    borderRadius: 4,
    padding: 8,
    borderWidth: 1,
    borderStyle: "solid",
    borderImage: "linear-gradient(to right, #40c440, #0a66b7) 1",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
  },
  cardDesc: {
    gap: 10,
  },
  supportedCon: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "left",
    gap: "8px",
  },
  suppLogoBox: {
    height: "40px",
    width: "64px",
    paddingInline: "12px",
    paddingTop: "8px",
    borderRadius: "1.85px",
    borderStyle: "solid",
    borderWidth: "0.23px",
    borderColor: "#BEDEF8",
  },
  suppLogoPverify: {
    height: "22px",
    width: "39px",
  },
  suppLogoAvaility: {
    height: "16px",
    width: "40px",
  },
  buttonBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "right",
    alignItems: "bottom",
  },
  modalBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    alignItems: "center",
    gap: "10px",
  },
 
 
}));

export const EmbedAppsLaunch = () => {
  const { classes } = useStyles();


 


  return (
    <>
      <Paper className={classes.default}>
        <Box sx={{}}>
          <Box className={classes.box1}>
            <Box>
              <Box className={classes.Boxtitle}>
                <Title className={classes.title}>Smart On FHIR Apps</Title>
              </Box>
            </Box>
          </Box>
          <SimpleGrid cols={2} spacing={24} mt="xl" verticalSpacing="xl">
            {embedApps.map((ins, i) => (
              <Card
                padding="lg"
                radius="md"
                withBorder
                className={classes.card}
              >
                <Box className={classes.cardHeading}>
                  <Box className={classes.iconBox} mr={12}>
                    <img
                      style={{ verticalAlign: "top",width:"25px" }}
                      src={healthConnnectLaunchIcon}
                    />
                  </Box>
                  <Title order={6} color="#262930" weight={600} size={14}>
                    {ins.title}
                  </Title>
                </Box>
                <Text
                  weight={400}
                  size={14}
                  color="#474E5B"
                  lh={"22px"}
                  mb={16}
                  mih={"110px"}
                  className={classes.cardDesc}
                >
                  {ins.desc}
                </Text>

                <SimpleGrid cols={2} spacing={"xl"}>
                  <Box className={classes.supportedCon}></Box>
                  <Box className={classes.buttonBox}>
                    <Button
                      variant="outline"
                      w={"max-content"}
                      // className={classes.proceedBtn}
                      onClick={() => {
                        if(ins?.nav){
                        window.open(ins.nav);
                        }
                        else{
                          showNotification({ color: 'orange', message: "Coming soon!", autoClose: true });

                        }
                      }}
                    >
                      <Text mt={1} size={"14px"} weight={500}>
                        Launch
                      </Text>
                      <IconArrowRight
                        style={{ marginLeft: "8px" }}
                        size={"18px"}
                      />
                    </Button>
                  </Box>
                </SimpleGrid>
              </Card>
            ))}
          </SimpleGrid>
        </Box>
      </Paper>
    </>
  );
};
